<template>
  <div class="dashboard md-layout md-size-80 md-small-size-90">
    <portfolio-widget
      class="md-layout-item"
      :currentAsset="currentToken"
      :accountState="accountState"
      :tronSum="sumTron"
      :subwallets="[]"
      @asset-change="setCurrentAsset"
    />
    <!--
      :subwallets="subwalletsFiltered"
      @setSubFull="setSubFull"
      @toggleAdd="toggleAdd"
      @setActiveSubwallet="setActiveSubwallet"
    -->
    <!-- <sub-wallets-widget
      class="md-layout-item"
      :accountBalances="accountBalances"
      :currentAsset="currentToken"
      :subwallets="subwallets"
      :filtered="subwalletsFiltered"
      @setSubFull="setSubFull"
      @toggleAdd="toggleAdd"
      @setActiveSubwallet="setActiveSubwallet"
    /> -->
    <info-widget
      :currentAsset="currentToken"
      :accountState="accountState"
      class="md-layout-item"
    />
    <!-- <AddSubwalletModal v-if="isCreateSubWallet" :active="isCreateSubWallet" :values="subwallets"
    :currentAsset="currentToken"
    :mains="subwalletsMains"
    :clients="clients"
    :descriptions="descriptions"
    @create="createSubWallet" @close="toggleAdd"/>
    <DeleteSubwalletModal v-if="isActiveSubwalletData" :active="isActiveSubwalletData" :values="activeSubwallet"
    @deleteSubWallet="deleteSubwallet"
    @close="setActiveSubwallet"
    @setActiveTransfer="setActiveTransfer"
    @setActiveChange="setActiveChange"/>
    <TransferSubModal v-if="isAtiveSubWalletTransfer" :active="isAtiveSubWalletTransfer"
    :sub="activeSubwallet" :wallets="subwallets"
    @transfer="transfer"
    @close="setActiveTransfer"
    />
    <ChangeSubwalletModal v-if="isActiveChange" :active="isActiveChange" :values="activeSubwallet"
    :clients="clients"
    :descriptions="descriptions"
    @changeWalletData="changeWalletData"
    @close="setActiveChange"/> -->
  </div>
</template>

<script>
  import PortfolioWidget from './Dashboard.PortfolioWidget'
  import InfoWidget from './Dashboard.InfoWidget'
  import SubWalletsWidget from './Dashboard.SubWalletsWidget'
  import TransferSubModal from './TransferSubModal'
  import ChangeSubwalletModal from './ChangeSubwalletModal.vue'
  import DeleteSubwalletModal from './DeleteSubwalletModal'
  import AddSubwalletModal from './AddSubwalletModal'
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { vueRoutes } from '@router/const'
  import { i18n } from '@js/i18n'
  // import { withdrawUSDTService } from '@api/withdraw_usdt.service'
 /* eslint-disable */

  export default {
    name: 'dashboard',
    components: {
      PortfolioWidget,
      InfoWidget,
      DeleteSubwalletModal,
      AddSubwalletModal,
      SubWalletsWidget,
      TransferSubModal,
      ChangeSubwalletModal
    },
    data: _ => ({
      currentToken: null,
      routes: [],
      i18n,
      // subwallets: null,
      // clients: null,
      // descriptions: null,
      // activeSubwallet: null,
      // isActiveSubwalletData: false,
      // isCreateSubWallet: false,
      // isSubFull: false,
      // isAtiveSubWalletTransfer: false,
      isActiveChange: false
    }),
    created () {
      this.setCurrentAsset(this.currentAsset)
    },
    // async mounted () {
    //   await this.getSubWallets()
    //   await this.getClients()
    //   await this.getDescriptions()
    // },
    computed: {
      ...mapGetters([
        vuexTypes.accountBalances,
        vuexTypes.currentAsset,
        vuexTypes.accountState,
        vuexTypes.accountId
      ]),
      sumTron () {
        let sum = [
          this.accountBalances.USDTBEP20 ? +this.accountBalances.USDTBEP20.balance : 0,
          this.accountBalances.USDTERC20 ? +this.accountBalances.USDTERC20.balance : 0,
          this.accountBalances.USDTTRC20 ? +this.accountBalances.USDTTRC20.balance : 0,
          this.accountBalances.USDTBEP20D ? +this.accountBalances.USDTBEP20D.balance : 0,
          this.accountBalances.USDTERC20D ? +this.accountBalances.USDTERC20D.balance : 0,
          this.accountBalances.USDTTRC20D ? +this.accountBalances.USDTTRC20D.balance : 0,
        ].reduce((partialSum, a) => partialSum + a, 0)

        sum = sum.toFixed(6).replace(/0+$/, '').replace(/\.$/, '')
        return sum
      },
      // subwalletsFiltered () {
      //   if (this.subwallets) {
      //     return this.subwallets.filter(wallet => wallet.Description !== 'main')
      //   }
      //   return []
      // },
      // subwalletsMains () {
      //   if (this.subwallets)  {
      //     return this.subwallets.filter(wallet => wallet.Description === 'main')
      //   }
      //   return []
      // }
    },
    methods: {
      ...mapActions({
        loadBalances: vuexTypes.GET_ACCOUNT_BALANCES,
        commitAsset: vuexTypes.COMMIT_CURRENT_ASSET
      }),
      // toggleAdd () {
      //   this.isCreateSubWallet = !this.isCreateSubWallet
      // },
      // setSubFull () {
      //   this.isSubFull = !this.isSubFull
      // },
      // setActiveSubwallet (data) {
      //   this.activeSubwallet = data
      //   this.isActiveSubwalletData = !this.isActiveSubwalletData
      //   if ('transfer' in data) {
      //     this.isActiveSubwalletData = false
      //     this.$nextTick(() => {
      //       this.setActiveTransfer()
      //     })
      //   }
      //   if ('edit' in data) {
      //     this.isActiveSubwalletData = false
      //     this.$nextTick(() => {
      //       this.setActiveChange()
      //     })
      //   }
      // },
      // setActiveChange () {
      //   this.isActiveChange = !this.isActiveChange
      // },
      // setActiveTransfer () {
      //   this.isAtiveSubWalletTransfer = !this.isAtiveSubWalletTransfer
      // },
      // async changeWalletData (obj) {
      //   await Promise.all([
      //     withdrawUSDTService.changeClietnBySubwallet({ wallet_id: obj.walletId, client_name: obj.client }),
      //     withdrawUSDTService.changeDesciptionBySubwallet({ wallet_id: obj.walletId, description: obj.desc })
      //   ])
      //   await Promise.all([this.getSubWallets(), this.getClients(), this.getDescriptions()])
      //   this.setActiveChange()
      // },
      // async transfer (obj) {
      //   // await withdrawUSDTService.transfertToWallet(obj)
      //   // await this.getSubWallets()
      //   this.setActiveTransfer()
      // },
      // async getClients () {
      //   const {_parsedData: res} = await withdrawUSDTService.getSubWalletsClients({
      //     user_id: this.accountId
      //   })
      //   this.clients = res
      //   this.clients = this.clients.filter(wallet => wallet !== 'main')
      // },
      // async getDescriptions () {
      //   const {_parsedData: res} = await withdrawUSDTService.getSubWalletsDescriptions({
      //     user_id: this.accountId
      //   })
      //   this.descriptions = res
      //   this.descriptions = this.descriptions.filter(wallet => wallet !== 'main')
      // },
      // async getSubWallets () {
      //   const {_parsedData: res} = await withdrawUSDTService.getSubWallets({
      //     user_id: this.accountId
      //   })
      //   this.subwallets = res
      //   this.subwallets = this.subwallets.map(el => {
      //     return {
      //       ...el,
      //       Balance: Number(el.Balance / 1000000).toFixed(2)
      //     }
      //   })
      // },
      // async deleteSubwallet (id) {
      //   await withdrawUSDTService.deleteSubWallet({
      //     wallet_id: id
      //   })
      //   await this.getSubWallets()
      // },
      // async createSubWallet (params) {
      //   await withdrawUSDTService.createSubWallet(params)
      //   await this.getSubWallets()
      // },
      setCurrentAsset (value) {
        const codes = Object.keys(this.accountBalances)
        const idx = codes.indexOf('UAH')
        this.currentToken = value ||
          codes[idx !== -1 && idx < codes.length ? idx : 0] ||
          null
        this.commitAsset(this.currentToken)
        this.loadBalances()
      },
      goToVerification () {
        this.$router.push(vueRoutes.verification)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins.scss';

  .dashboard {
    margin: auto;
    justify-content: center;
    flex-wrap: nowrap;

    @include respond-to(medium) {
      flex-direction: column;
      align-items: normal;
      flex-wrap: wrap;
    }
    @include respond-from(xlarge) {
      max-width: 1400px;
      flex: 0 1 1400px;
      min-width: 1400px;
    }

    & *:last-child {
      margin-left: 20px;

      @include respond-to(medium) {
        margin-left: 0;
      }
    }

    &__verification {
      display: flex;
      flex-basis: 100%;
      max-width: 954px;
      min-height: 52px;
      margin: 0 12px 12px;
      padding: 6px 8px 6px 24px;
      justify-content: space-between;
      align-items: center;
      font-size: 20px;
      background-color: #fff;
      @include respond-to(medium-tablet) {
        flex-direction: column;
      }
      @include respond-to(medium) {
        max-width: inherit;
        width: 100%;
        font-size: 16px;
      }
      @include respond-to(small) {
        margin: 0 0 12px;
        padding-left: 16px;
      }
      @include respond-to(xsmall) {
        max-width: 100%;
      }

      &-description {
        margin-right: 8px;
        @include respond-to(medium-tablet) {
          margin-right: 0;
          margin-bottom: 8px;
        }
      }

      &-pending {
        margin: auto;
      }

      &-btn {
        flex-shrink: 0;
        margin: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/index/Dashboard.Old.Index.vue